import styled, { css } from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OcurrencesWrapper = styled.div`
  display: flex;
  align-items: center;

  ${({ isMobile }) => !isMobile && css`
    justify-content: center;
  `}

  div {
    max-width: fit-content;
    border-radius: 4px;
    padding: 4px;
    flex: 1;
    display: flex;
    align-items: center;
    color: ${({ hasOccurence }) =>
      hasOccurence ? '#263465' : 'rgba(0, 0, 0, 0.26)'};
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    cursor: ${({ hasOccurence }) => (hasOccurence ? 'pointer' : 'not-allowed')};
    transition: ease 0.2s;

    span {
      font-weight: 400;
      font-size: 14px;
      font-family: 'Work Sans';
    }

    i {
      margin-right: 4px;
      font-size: 14px;
    }
    &:hover {
      background-color: ${({ hasOccurence }) =>
        hasOccurence ? '#C6DEEE' : 'none'};
    }
  }
`;

export const EmailTrackingContainer = styled.div`
  display: flex;
  align-items: center;

  && .TrackingNFItem__email-tracking {
    padding: 0;
    margin-top: 0;
  }

  i,
  span {
    color: var(--light-opacity-gray);
    font-size: 14px;
    text-align: right;
  }
`;
